import script from "./fileImport.vue?vue&type=script&lang=ts&setup=true"
export * from "./fileImport.vue?vue&type=script&lang=ts&setup=true"

import "./fileImport.vue?vue&type=style&index=0&id=48df0c02&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-48df0c02"]])

export default __exports__